import { render, staticRenderFns } from "./RemoveMyCustomer.vue?vue&type=template&id=2c2c9824&scoped=true&"
import script from "./RemoveMyCustomer.vue?vue&type=script&lang=js&"
export * from "./RemoveMyCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2c9824",
  null
  
)

export default component.exports